import createIcon from '../../createIcon';

/**
 * @component @name NetworkLocked
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTkuNSAxMC41QzE5LjY3IDEwLjUgMTkuODMgMTAuNTMgMjAgMTAuNTVWMS41TDEgMjAuNUgxNFYxNy41QzE0IDE2LjYxIDE0LjM5IDE1LjgyIDE1IDE1LjI3VjE1QzE1IDEyLjUyIDE3LjAyIDEwLjUgMTkuNSAxMC41Wk0yMiAxNi41VjE1QzIyIDEzLjYyIDIwLjg4IDEyLjUgMTkuNSAxMi41QzE4LjEyIDEyLjUgMTcgMTMuNjIgMTcgMTVWMTYuNUMxNi40NSAxNi41IDE2IDE2Ljk1IDE2IDE3LjVWMjEuNUMxNiAyMi4wNSAxNi40NSAyMi41IDE3IDIyLjVIMjJDMjIuNTUgMjIuNSAyMyAyMi4wNSAyMyAyMS41VjE3LjVDMjMgMTYuOTUgMjIuNTUgMTYuNSAyMiAxNi41Wk0yMSAxNi41SDE4VjE1QzE4IDE0LjE3IDE4LjY3IDEzLjUgMTkuNSAxMy41QzIwLjMzIDEzLjUgMjEgMTQuMTcgMjEgMTVWMTYuNVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const NetworkLocked = createIcon('NetworkLocked', [
  [
    'path',
    {
      d: 'M19.5 10.5C19.67 10.5 19.83 10.53 20 10.55V1.5L1 20.5H14V17.5C14 16.61 14.39 15.82 15 15.27V15C15 12.52 17.02 10.5 19.5 10.5ZM22 16.5V15C22 13.62 20.88 12.5 19.5 12.5C18.12 12.5 17 13.62 17 15V16.5C16.45 16.5 16 16.95 16 17.5V21.5C16 22.05 16.45 22.5 17 22.5H22C22.55 22.5 23 22.05 23 21.5V17.5C23 16.95 22.55 16.5 22 16.5ZM21 16.5H18V15C18 14.17 18.67 13.5 19.5 13.5C20.33 13.5 21 14.17 21 15V16.5Z',
      key: 'hgm6ls',
    },
  ],
]);

export default NetworkLocked;
